<template>
	<b-card no-body tag="article">
		<b-card-header class="d-flex align-items-center">
			<h3 class="h6 mb-0 mr-auto">
				<b v-html="title" />
			</h3>

			<b-button
				:disabled="deleting"
				:title="$t('Delete')"
				class="ml-3"
				size="sm"
				variant="danger"
				@click="handleDelete"
			>
				<fa :title="$t('Delete')" icon="trash" />
			</b-button>
		</b-card-header>

		<b-form @submit.prevent="handleSave">
			<b-card-body>
				<div class="grid">
					<b-form-group
						v-if="isAmountFormula"
						:label="$t('Amount')"
						:label-for="uuid + '_amount'"
					>
						<b-form-input
							:id="uuid + '_amount'"
							v-model="form.amount"
							:name="uuid + '_amount'"
							inline
							min="0.01"
							required
							step="0.01"
							type="number"
						/>
					</b-form-group>

					<template v-if="isMeterFormula">
						<b-form-group
							v-for="multiplier in multipliers"
							:key="uuid + '_' + multiplier.name"
							:label="multiplier.label"
							:label-for=" uuid + '_' + multiplier.name"
						>
							<b-form-spinbutton
								:id="uuid + '_' + multiplier.name"
								v-model.number="form[multiplier.name]"
								inline
								min="-10"
							/>
						</b-form-group>
					</template>
				</div>

				<b-form-checkbox
					:id="uuid + '_unclear'"
					v-model="form.unclear"
					:name="uuid + '_unclear'"
					:unchecked-value="0"
					:value="1"
					inline
				>
					{{ $t('Unclear') }}
				</b-form-checkbox>

				<b-form-checkbox
					v-if="isAreaFormula"
					:id="uuid + '_small_area'"
					v-model="form.smallArea"
					:name="uuid + '_small_area'"
					inline
				>
					{{ $t('Is small area') }}
				</b-form-checkbox>

				<b-form-group
					v-if="form.unclear"
					:label="$t('Notice')"
					:label-for=" uuid + '_notice'"
				>
					<b-form-input
						:id="uuid + '_notice'"
						v-model="form.notice"
					/>
				</b-form-group>

				<b-form-group
					v-if="form.smallArea"
					:label="$t('Area')"
					:label-for="uuid + '_area'"
				>
					<b-input-group>
						<b-form-input
							:id="uuid + '_area'"
							v-model="form.area"
							:name="uuid + '_area'"
							min="0"
							required
							step="0.001"
							type="number"
						/>

						<b-input-group-append is-text>
							m<sup>2</sup>
						</b-input-group-append>
					</b-input-group>
				</b-form-group>

				<template v-if="isAreaFormula || isMeterFormula">
					<hr>
					<b-button v-b-toggle="'collapse-2'+uuid" variant="light" size="sm" class="d-block border">
						{{ $t('Value correction') }}
					</b-button>
					<b-collapse :id="'collapse-2'+uuid" class="mt-2">
<!--						<h4 class="h6 font-weight-bold">-->
<!--							{{ $t('Value correction') }}-->
<!--						</h4>-->
						<div class="grid">
							<b-form-group
								v-for="multiplier in multipliers"
								:key="uuid + '_' + multiplier.name + '_correction'"
								:label="multiplier.label"
								:label-for=" uuid + '_' + multiplier.name + '_correction'"
							>
								<b-form-input
									:id="uuid + '_' + multiplier.name + '_correction'"
									v-model.number="form[multiplier.name + '_correction']"
									step="any"
									type="number"
								/>
							</b-form-group>
						</div>
					</b-collapse>
				</template>
			</b-card-body>

			<b-card-footer v-if="apiUrl" class="text-left">
				<submit-button :pending="pending" />
			</b-card-footer>
		</b-form>
	</b-card>
</template>
<script>
import {clone} from 'lodash';
import SubmitButton from "@/components/SubmitButton";

export default {
	name: 'ServiceSelectItem',
	components: {SubmitButton},
	props: {
		value: {
			type: Object,
			default: () => ({}),
		},
		apiUrl: {
			type: String,
			default: null
		},
		multipliers: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			showModal: false,
			form: {},
			pending: false,
			deleting: false,
		};
	},
	computed: {
		title() {
			return this.value.formatted_string;
		},
		isAmountFormula() {
			return this.value.unit === 'St'
		},
		isAreaFormula() {
			return this.value.unit === 'm2'
		},
		isMeterFormula() {
			return this.value.unit === 'm'
		},
	},
	watch: {
		value: {
			handler(newValue) {
				const formClone = clone(newValue.info)
				if (formClone && formClone.depth === null) {
					formClone.depth = 0
				}

				this.form = {
					amount: 1,
					width: 0,
					height: 0,
					depth: 0,
					length: 0,
					a: 0,
					b: 0,
					c: 0,
					d: 0,
					h: 0,
					soffit: 0,
					width_correction: 0,
					height_correction: 0,
					depth_correction: 0,
					length_correction: 0,
					soffit_correction: 0,
          a_correction: 0,
          b_correction: 0,
          c_correction: 0,
          d_correction: 0,
          h_correction: 0,
					...formClone
				};
			},
			immediate: true
		},
	},
	methods: {
		async handleDelete() {
			if (this.deleting) return;

			this.deleting = true;

			try {
				if (this.apiUrl) {
					await this.axios.delete(this.apiUrl)

					this.savedToast();
				}
				this.$emit('deleted');
			} finally {
				this.deleting = false;
			}
		},

		async handleSave() {
			if (this.pending || !this.apiUrl) return;

			this.pending = true;

			try {
				await this.axios.put(this.apiUrl, this.form);
				this.savedToast();
				this.$emit('input', this.form);
			} catch (e) {
				if (!e.response) {
					throw e;
				}
			} finally {
				this.pending = false;
			}
		}
	}
};
</script>
<style scoped>
article > .form-group {
	margin-top: 1rem;
}

.grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
	gap: 1rem;
}
</style>
